import { Reveal } from "./Reveal";
import { PrimaryButton } from "./Buttons";
import { trackEvent } from "../../lib/analytics";

export const CtaBanner = () => (
  <section data-testid="cta-banner" className="relative overflow-hidden bg-gradient-to-r from-[#006FD6] via-[#0086EC] to-[#009BFF]">
    <div className="absolute inset-0 mst-grid-pattern opacity-50" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#041525]/25 to-transparent" />
    <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#00C4F4]/30 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.1]">
          Ready to Be Part of Something Bigger?
        </h2>
        <p className="mt-5 text-white/90 leading-[1.8] max-w-xl">
          Join a private network of entrepreneurs, investors, founders, professionals, and
          leaders building multiple streams and lasting legacies together.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <PrimaryButton
          to="/apply"
          data-testid="cta-apply-btn"
          onClick={() => trackEvent("apply_membership_click", { location: "cta_banner" })}
          className="!bg-none !bg-white !text-[#041525] !px-10 !py-4 shadow-[0_10px_35px_rgba(2,10,18,0.35)] hover:!bg-[#F6F8FA]"
        >
          Apply for Membership
        </PrimaryButton>
      </Reveal>
    </div>
  </section>
);
